import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

// El que hace que el programa abra sin señal.
//
// Se registra DESPUÉS de que la página cargó —en el evento 'load'— para no
// competir por la red con el propio programa la primera vez que alguien entra.
//
// Si el navegador no lo soporta, no pasa nada: el programa funciona igual con
// señal. Por eso el fallo se traga en vez de avisar; no hay nada que la
// persona pueda hacer al respecto.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
